import { render, staticRenderFns } from "./AgeAtFirstDiagnosisChart.vue?vue&type=template&id=d385efca"
import script from "./AgeAtFirstDiagnosisChart.vue?vue&type=script&lang=ts"
export * from "./AgeAtFirstDiagnosisChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports